import * as React from "react";
import { styled } from "theme";
import { motion } from "framer-motion";
import useImage from "hook/useImage";

export interface Props {
  src: string;
  count: number;
  done: () => void;
}

const CubeImage: React.FC<Props> = ({ src, count, done }) => {
  const { status } = useImage(src);

  if (status !== "complete") return null;
  return (
    <CubeImageContainer
      src={src}
      count={count}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      onAnimationComplete={() => {
        done();
      }}
    />
  );
};

export default React.memo(CubeImage);

const _CubeImageContainer = styled.div<{ src: string; count: number }>`
  background: transparent url('${(props) => props.src}') no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: ${(props) => props.count + 1};
`;

const CubeImageContainer = motion.custom(_CubeImageContainer);
